import { ClockIllustration } from '../../assets/illustrations';
import { Headings } from '../Headings';
import { Flex } from '../Layout';
import { Link } from '../Link';
import { Text } from '../Text';
import { ErrorPageProps } from './ErrorPage';

export const ErrorPage401 = ({ title, message, links }: ErrorPageProps) => {
  return (
    <>
      <Headings.H1>{title || 'Du har blivit utloggad'}</Headings.H1>
      <ClockIllustration width={[180, 180, 220]} />
      <Text size="large">{message || 'Du behöver logga in igen för att kunna fortsätta använda tjänsten.'}</Text>
      <Flex flexDirection="column" rowGap={20}>
        {links &&
          links.map(({ linkText, linkUrl }, index) => {
            return (
              <Link to={linkUrl} key={index} fontSize="large">
                {linkText}
              </Link>
            );
          })}
      </Flex>
    </>
  );
};
